// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-user-dialog.common-dialog[data-v-2dd1b180] .el-dialog{width:var(--common-dialog-medium-width)}.create-user-dialog.common-dialog .el-form[data-v-2dd1b180]{margin-right:var(--common-dialog-form-margin-right)}.create-user-dialog.common-dialog .el-form[data-v-2dd1b180] .el-select{width:100%}", ""]);
// Exports
module.exports = exports;
